import { render, staticRenderFns } from "./FeedContentNewCompanyLead.vue?vue&type=template&id=c3b481f4"
import script from "./FeedContentNewCompanyLead.vue?vue&type=script&lang=js"
export * from "./FeedContentNewCompanyLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports